import SingleUserRoute from './SingleUserRoute';

export default SingleUserRoute;
